import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./header.css"

const BANNER_KEY = "nwd_donation_banner_dismissed";
const DISMISS_DURATION_MS = 30 * 24 * 60 * 60 * 1000;



export default function DonationBanner() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/donate" || location.pathname === "/donate-success") {
      setVisible(false);
      return;
    }
    const dismissed = localStorage.getItem(BANNER_KEY);
    if (!dismissed) {
      setVisible(true);
      return;
    }
    const dismissedAt = parseInt(dismissed, 10);
    if (Date.now() - dismissedAt > DISMISS_DURATION_MS) {
      localStorage.removeItem(BANNER_KEY);
      setVisible(true);
    }
  }, [location.pathname]);

  const handleDismiss = (e) => {
    e.stopPropagation();
    localStorage.setItem(BANNER_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="donation-banner" onClick={() => navigate("/donate")}>
      <span className="donation-banner__text">
NoWastedDays will always be available for free but how many people the platform reaches and helps will be completely dependent on donations. Consider supporting
        <strong> from £3/month or less.</strong>
      </span>
      <button className="donation-banner__cta" onClick={(e) => { e.stopPropagation(); navigate("/donate"); }}>
        Support here
      </button>
      <button className="donation-banner__close" onClick={handleDismiss} aria-label="Dismiss">
        &times;
      </button>
    </div>
  );
}
